import { gql } from "@apollo/client";

export const GET_QUIZ = gql`
query getQuizzes($input: getQuizInput!) {
  getAllQuizzes(input: $input) {
    allquizzes {
      createdAt
      isClassroom
      questions
      quizId
      quizTitle
      totalQuestions
      status
      totalScore
      results
      feedId
    }
    totalCount
  }
}
`;

export const CREATE_QUIZ = gql`
mutation createQuiz($input: quizInput!) {
  createNewQuiz(input: $input) {
    message
  }
}
`;

export const UPDATE_QUIZ = gql`
mutation updateQuiz($cId: UUID!, $isClassroom: Boolean! = false, $qzId: UUID!, $sjId: UUID!) {
  updateQuizIsClassroom(input: {pClassroomId: $cId, pIsClassroom: $isClassroom, pQuizId: $qzId, pSubjectId: $sjId}) {
    clientMutationId
  }
}
`;

export const DELETE_QUIZ = gql`
mutation deleteQuiz($cId: String!, $qzId: String!, $sjId: String!) {
  deleteQuizMaterials(cId: $cId, qzId: $qzId, sjId: $sjId)
}
`;

export const UPDATE_QUIZ_RESULTS = gql`
mutation updateQuizResults($cId: String!, $qzId: String!, $resultInfo: [answer!]!, $sjId: String!,$isContinue:Boolean!) {
  updateQuizResults(
    input: {cId: $cId, sjId: $sjId, qzId: $qzId, resultInfo: $resultInfo, isContinue: $isContinue}
  ) {
    message
    colorCode
    totalQuestions
    totalScore
  }
}
`;

export const GET_QUIZ_RESULTS = gql`
query getQuizResults($cId: UUID!, $sjId: UUID!, $limit: Int = null, $offset: Int = null) {
  getQuizResults(
    classroomId: $cId
    subjectId: $sjId
    first: $limit
    offset: $offset
  ) {
    nodes {
      questionsCount
      quizId
      quizTitle
      students
      totalCompletedStudents
    }
    totalCount
  }
}
`;

export const EDIT_QUIZ = gql`
mutation editQuiz($input: editQuizInput!) {
  editQuiz(input: $input)
}
`;